import { __rest } from '../common/temp/node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { clsx } from '../../../../common/temp/node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js';
import { forwardRef, useState } from 'react';
import { withStyleProps } from '../_common/hocs/styleProps/withStyleProps.js';
import '../_common/hocs/styleProps/styleProps.config.js';
import '../tokens/tokens-base/properties/build/js/index.js';
import '../common/temp/node_modules/.pnpm/deepmerge@4.2.2/node_modules/deepmerge/dist/cjs.js';
import { noop } from '../_common/utils/common.js';
import { StyledImageConstructor, StyledPicture } from './Image.styles.js';
import { getImageTypeFromFormat, getSourceSetMedia } from './Image.utils.js';
const ImageComponent = forwardRef((props, ref) => {
  const {
      alt = '',
      loading = 'lazy',
      sets = [],
      objectFit = 'fill',
      objectPosition = '50% 50%',
      placeholder,
      onLoad = noop,
      className
    } = props,
    imageProps = __rest(props, ["alt", "loading", "sets", "objectFit", "objectPosition", "placeholder", "onLoad", "className"]);
  const StyledImage = StyledImageConstructor(objectFit, objectPosition);
  const [imageLoaded, setImageLoaded] = useState(false);
  const onImageLoad = event => {
    onLoad(event);
    setImageLoaded(true);
  };
  const showPlaceholder = placeholder && !imageLoaded;
  const IMG_ELEMENT = jsx(StyledImage, Object.assign({}, imageProps, {
    alt: alt,
    loading: loading,
    onLoad: onImageLoad,
    className: clsx('Copan_Image', className),
    ref: ref
  }), void 0);
  return jsxs(StyledPicture, {
    children: [sets.map((_ref, index) => {
      let {
        media,
        src
      } = _ref;
      return jsx("source", {
        srcSet: src,
        type: getImageTypeFromFormat(src),
        media: getSourceSetMedia(media)
      }, `set-source-${index}`);
    }), showPlaceholder && jsx("source", {
      srcSet: placeholder,
      type: getImageTypeFromFormat(placeholder)
    }, void 0), IMG_ELEMENT]
  }, void 0);
});
ImageComponent.displayName = 'ReactBase_Image';
const Image = withStyleProps(ImageComponent);
export { Image };